import { render, staticRenderFns } from "./CheckmarkSvg.vue?vue&type=template&id=4131b114"
import script from "./CheckmarkSvg.vue?vue&type=script&lang=js"
export * from "./CheckmarkSvg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports